export default __webpack_public_path__ + "static/G_BG_COLORED-bc0a56e77b688e3f6709d40066d47342.png";